import {timestampToText} from "@/store/helpers/event-timestamp";

export default {
    namespaced: true,
    state: {
        startDate: null,
        endDate: null,
    },
    getters: {
        getDateRange(state) {
            return {...state};
        },
        getHumanReadableRange({startDate, endDate}) {
            if (startDate || endDate) {
                const start = startDate
                    ? timestampToText(+new Date(startDate) / 1000, true)
                    : '...';
                const end = endDate
                    ? timestampToText(+new Date(endDate) / 1000, true)
                    : '...';
                return `${start} - ${end}`;
            }
            return null;
        },
        isValid(state) {
            return Boolean(state.startDate) && Boolean(state.endDate);
        }
    },
    mutations: {
        setDateRange(state, {startDate, endDate}) {
            state.startDate = startDate ?? null;
            state.endDate = endDate ?? null;
        },
        setDateRangeAsTimestamps(state, {startDateTimestamp, endDateTimestamp}) {
            if (!startDateTimestamp || !endDateTimestamp) {
                return;
            }
            state.startDate = new Date(startDateTimestamp * 1000);
            state.endDate = new Date(endDateTimestamp * 1000);
        },
        clearDate(state) {
            state.startDate = null;
            state.endDate = null;
        }
    },
    actions: {
        setDate({commit, dispatch}, {startDate, endDate}) {
            commit('setDateRange', {startDate, endDate});
            dispatch('clearDateDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearDate({commit, dispatch}) {
            commit('clearDate');
            dispatch('clearDateDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearDateDependencies({dispatch}) {
            dispatch('address/clearAddress', null, {root: true});
        }
    }
}
